import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconThumbsUp = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--thumbs-up")} iconColor={color} size={size} width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

      <defs>
          <path d="M19.6486763,8.00006412 C20.5288038,7.99009715 21.368906,8.36714393 21.946464,9.03133562 C22.524022,9.69552732 22.7807603,10.5798471 22.6484478,11.451562 L21.2686957,20.4499361 C21.0443874,21.9290503 19.7646258,23.0168476 18.28,23.000193 L7,23.000193 C6.44771525,23.000193 6,22.5522847 6,22 L6,11 C6,10.8600817 6.02936223,10.7217205 6.08618845,10.5938615 L10.0861885,1.59386153 C10.2466898,1.23273352 10.6048113,1 11,1 C13.209139,1 15,2.790861 15,5 L15,8.00001135 L19.6486763,8.00006412 Z M6,12 L4,12 C3.44771525,12 3,12.4477153 3,13 L3,20 C3,20.5522847 3.44771525,21 4,21 L6,21 L6,12 Z M7,23 L4,23 C2.34314575,23 1,21.6568542 1,20 L1,13 C1,11.3431458 2.34314575,10 4,10 L7,10 C7.55228475,10 8,10.4477153 8,11 L8,22 C8,22.5522847 7.55228475,23 7,23 Z M8,21.0001287 L18.2913043,21.0001287 C18.7899477,21.0057011 19.2165349,20.643102 19.2915522,20.148438 L20.6713237,11.1499359 C20.7153517,10.8598635 20.6297723,10.5650903 20.437253,10.3436931 C20.2447337,10.1222958 19.9646996,9.99661356 19.66,10 L14,10 C13.4477153,10 13,9.55228475 13,9 L13,5 C13,4.107435 12.4153102,3.35143161 11.6080478,3.09410694 L8,11.2122145 L8,21.0001287 Z" id="icon--centivo--thumbs-up"/>
      </defs>
      <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-1565.000000, -1198.000000)"/>
          <g id="Icon/thumbs-up">
              <mask id="mask-2" fill="white">
                  <use xlinkHref="#icon--centivo--thumbs-up"/>
              </mask>
              <use id="Shape" fill="currentColor" xlinkHref="#icon--centivo--thumbs-up"/>
          </g>
      </g>
  </IconWrapper>
)
